export enum FightChoice {
  CritStrike,
  NormStrike,
  CritParry,
  NormParry
}

export default FightChoice;